export default __webpack_public_path__ + "static/media/info.7a2368bf.svg";